import { render, staticRenderFns } from "./assignForm.vue?vue&type=template&id=6d543e03&scoped=true"
import script from "./assignForm.vue?vue&type=script&lang=js"
export * from "./assignForm.vue?vue&type=script&lang=js"
import style0 from "./assignForm.vue?vue&type=style&index=0&id=6d543e03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d543e03",
  null
  
)

export default component.exports